import styled from 'styled-components';

export const SceneryList = styled.div`
    margin: 3px 0 0;
    width: 100%;
    height: 150px;
    border: 1px solid #555;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const Error = styled.div`
    border: 1px solid rgba(255,0,0, 0.6);
    background-color: rgba(255,0,0, 0.4);
    width: 100%;
    padding: 0 5px;
    height: 30px;
    display: flex;
    color: #fff;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 22px;
`;

export const SceneryFullButtonForm = styled.div`
    flex: 1;
    height: 30px;
    margin: 22px 0 0;
    color: ${props => props.color ?? '#0c0'};
    transition: all .4s ease 0s;
    border: 1px solid ${props => props.color ?? '#0c0'};
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    :hover {
        color: #000;
        background-color: ${props => props.color ?? '#0c0'};
    }

    :not(:last-child) {
        margin-right: 10px;
    }
`;

export const SceneryItem = styled.div`
    width: 100%;
    height: 25px;
    min-height: 25px;
    font-size: 14px;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 5px;

    :hover {
        background-color: #333;
    }

    &.selected {
        background-color: #444;
        font-weight: 900;
    }
`;

export const SceneryForm = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: stretch;
    margin: 10px 0 0;
`;

export const SceneryProps = styled.div`
    margin: 10px 0 0;
`;

export const SceneryField = styled.div.attrs(props => ({
    style: {
        marginTop: props.internal ? '0px' : '10px',
        marginRight: props.first ? '10px' : '0px'
    }
}))`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: stretch;
    width: 100%;
`;

export const SceneryLabel = styled.div`
    font-size: 12px;
    color: #666;
    text-transform: uppercase;
    width: 100%;
`;

export const SceneryInput = styled.input`
    width: 100%;
    background-color: #000;
    color: #aaa;
    border: 1px solid #444;
    height: 30px;
    padding: 0 5px;

    :focus {
        outline-color: ${props => props.theme.colors.main};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
`;

export const ScenerySelect = styled.select`
    width: 100%;
    background-color: #000;
    color: #aaa;
    border: 1px solid #444;
    height: 30px;
    padding: 0 5px;

    :focus {
        outline-color: ${props => props.theme.colors.main};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
`;

export const SceneryActionConfirm = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    margin: 10px 0 0;
`;

export const SceneryActionConfirmButtons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    width: 100%;
    margin-top: 10px;
`;

export const SceneryAction = styled.div`
    width: 100px;
    height: 30px;
    background-color: transparent;
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    transition: all .4s ease 0s;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-left: 10px;

    :hover {
        background-color: ${props => props.color};
        color: #fff;
    }
`;

export const SceneryActive = styled.div`
    background-color: #ccc;
    color: #000;
    padding: 0 10px;
    font-size: 10px;
    font-weight: bold;
    height: 20px;
    margin-right: 10px;
    border-radius: 10px;
    text-transform: uppercase;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;